import type { ReactNode } from 'react';
import React from 'react';
import { Provider } from 'react-redux';

import type { AppStore } from '../store';

interface IProps {
  store: AppStore;
  children: ReactNode;
}

export const StoreProvider: React.FC<IProps> = ({ store, children }) => <Provider store={store}>{children}</Provider>;
